import { useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import Link from '../Atoms/Link';
import Image from '../Atoms/Image';
import ArrowButton from '../Atoms/ArrowButton';

export type ProductCardProps = {
  title: string;
  price?: number | string | null;
  image: string;
  link: string;
  border?: boolean;
  className?: string;
  imageClass?: string;
  imageWrapperClass?: string;
  textWrapperClass?: string;
  imageWrapperSubClass?: string;
  buttonClass?: string;
  hasAnimatedImage?: boolean;
  type?: 'buy' | 'sell';
  linkStyle?: string;
  priceStyle?: string;
}

const ProductCard = (({
  title,
  price,
  image,
  link,
  border = false,
  className = '',
  imageClass = "h-full object-cover",
  imageWrapperClass = "",
  textWrapperClass = "",
  imageWrapperSubClass = "",
  buttonClass = "",
  hasAnimatedImage = true,
  type = 'sell',
  linkStyle = 'my-4 lg:mb-12',
  priceStyle = '',
}: ProductCardProps) => {
  const { t } = useTranslation();
  const [imgSrc, setImgSrc] = useState(image);

  const handleImageLoadingError = () => {
    setImgSrc('https://valoracion.cdbarcelona.com/img/layout/default.jpg');
  }

  return (
    <article className={`min-w-40 lg:min-w-80 hover:shadow-md ${border ? 'border border-primary' : ''} ${className}`}>
      <Link to={link} className={`md:h-1/2 bg-white flex items-center justify-center ${imageWrapperClass}`}>
        <div className={`h-full w-full flex justify-center items-center ${imageWrapperSubClass}`}>
          {
            hasAnimatedImage
              ? <Image src={imgSrc} alt={title} className={imageClass} data-imgsrc={image} onError={handleImageLoadingError} loading="lazy" />
              : <img src={imgSrc} alt={title} className={imageClass} data-imgsrc={image} onError={handleImageLoadingError} loading="lazy" />
          }
        </div>
      </Link>
      <div className={`bg-white p-4 flex flex-col md:h-1/2 ${textWrapperClass}`} style={{ transform: 'translateZ(10px)' }}>
        <div className="flex flex-col bg-gray p-2 h-full w-full">
          <Link to={link} className={linkStyle}>
            <h3 className="text-primary font-cirka lg:text-3xl text-2xl line-clamp-2 block">{title}</h3>
          </Link>
          <div className={`flex ${type === 'sell' ? 'flex-col' : 'flex-row justify-between items-center'} mt-auto`}>
            {price && <span className={`font-roboto font-light text-xl text-gray-700 ${priceStyle}`}>{price === 0 ? t('general.priceOnDemand') : price}</span>}
            {type === 'sell' ? <SellingLink link={link} buttonClass={buttonClass} /> : <BuyingLink link={link} buttonClass={buttonClass} />}
          </div>
        </div>
      </div>
      {/* TODO: add hasSchemaOrg check and add data of a product */}
    </article>
  );
})

const SellingLink = ({ link, buttonClass }: { link: string, buttonClass: string }) => {
  const { t } = useTranslation();

  return (
    <Link to={link} className={`${buttonClass} no-animation mt-4 text-base flex items-center`}>
      <ArrowButton isGhost={false} />
      <span className="ml-4 text-lg">
        {t('form.submit')}
      </span>
    </Link>
  )
}

const BuyingLink = ({ link, buttonClass }: { link: string, buttonClass: string }) => (
  <Link to={link} className={`${buttonClass} no-animation flex items-center`}>
    <ArrowButton className="h-8 w-8 lg:h-12 lg:w-12" />
  </Link>
)

export default ProductCard;
